import { createClient } from '@supabase/supabase-js';

// A second Supabase client for pages where people sign in (currently only /redeem).
// The shared client in ./supabase never keeps a session, so the rest of the site is
// unaffected. This one keeps the session in localStorage under its own key.
//
// detectSessionInUrl is off on purpose: gift emails link to /redeem?code=TOAST-...,
// and Supabase would otherwise mistake that gift code for a sign-in code. The redeem
// page exchanges real sign-in codes itself (see Redeem.tsx).
const SUPABASE_URL = 'https://ljumoqywmjdjqamsjgdg.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_P0M3ntY2mAvXJ_4CDZonDg__2mvO41n';

export const supabaseAuth = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'toastie-web-auth',
  },
});
